import { render, staticRenderFns } from "./NpaHistoryChangesView.vue?vue&type=template&id=28f1f79f&scoped=true"
import script from "./NpaHistoryChangesView.vue?vue&type=script&lang=js"
export * from "./NpaHistoryChangesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1f79f",
  null
  
)

export default component.exports